import { render } from "./PopMenu.vue?vue&type=template&id=71e70916&scoped=true"
import script from "./PopMenu.vue?vue&type=script&lang=js"
export * from "./PopMenu.vue?vue&type=script&lang=js"

import "./PopMenu.vue?vue&type=style&index=0&id=71e70916&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71e70916"]])

export default __exports__